import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "t582ys83",
  dataset: "production",
});
